import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap";

// Connects to data-controller="show-modal"
export default class extends Controller {
  connect() {
    this.modal.show()
    document.addEventListener('turbo:submit-end', ev => this.handleSubmit(ev))
  }

  disconnect() {
    this.modal.hide()
    document.removeEventListener('turbo:submit-end', ev => this.handleSubmit(ev))
  }

  close() {
    this.modal.hide()
  }

  handleSubmit(e) {
    const form = e.target
    const keepOpen = (form.getAttribute('data-keep-modal-open') === 'true')

    if (e.detail.success && !keepOpen) {
      this.close()
    }
  }

  get modal() {
    return Modal.getOrCreateInstance(this.element)
  }

}
